import * as React from 'react';

import { Field } from 'formik';

interface CustomCheckboxProps {
	formikBag: any;
	capture: string;
	value?: string;
	onChangeChecked?: (e: boolean) => void;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
	formikBag,
	capture,
	value = 'isDisplayed',
	onChangeChecked,
}) => {
	const [checked, setChecked] = React.useState<boolean>(formikBag.values[value]);

	React.useEffect(() => {
		if (onChangeChecked) {
			onChangeChecked(checked);
		}
	}, [checked]);

	return (
		<Field name={value}>
			{() => {
				return (
					<div className="custom-checkbox">
						<input
							type="checkbox"
							checked={checked}
							onChange={() => setChecked(!checked)}
							value={value}
						/>
						<label
							onClick={() => {
								setChecked(!checked);
								formikBag.setFieldValue(value, !checked);
							}}
						>
							{capture}
						</label>
					</div>
				);
			}}
		</Field>
	);
};

export default CustomCheckbox;
